export const NAME = 'appReducer';
